import React, { Component, Fragment } from 'react'
import Home from '../pages/Home';
import Cart from '../pages/Cart';
import { Route, Routes } from 'react-router-dom';

class AppRoutes extends Component {
    render() {
      return (
        <Fragment>
            <Routes>
                <Route end path="/" element={<Home />} />
                <Route end path="/cart" element={<Cart />} />
            </Routes>
        </Fragment>
      );
    }
  }
  
  export default AppRoutes;